/** Rutas y claves de contenido para páginas SEO del mega menú. */
export const ORTHO_MENU_PAGES = [
  { id: 'metalBraces', path: '/ortodoncia/brackets-metalicos-cusco', category: 'ortodoncia' },
  { id: 'ceramicBraces', path: '/ortodoncia/brackets-ceramicos-cusco', category: 'ortodoncia' },
  { id: 'invisalign', path: '/ortodoncia/invisalign-cusco', category: 'ortodoncia' },
  { id: 'selfLigatingBraces', path: '/ortodoncia/brackets-autoligantes-cusco', category: 'ortodoncia' },
  { id: 'retainers', path: '/ortodoncia/retenedores-cusco', category: 'ortodoncia' },
  { id: 'klamm', path: '/ortopedia-maxilar/klamm-cusco', category: 'ortopedia-maxilar' },
  { id: 'bimler', path: '/ortopedia-maxilar/bimler-cusco', category: 'ortopedia-maxilar' },
  { id: 'planas', path: '/ortopedia-maxilar/planas-cusco', category: 'ortopedia-maxilar' },
  { id: 'stockfisch', path: '/ortopedia-maxilar/stockfisch-cusco', category: 'ortopedia-maxilar' },
  { id: 'clarkTwinBlock', path: '/ortopedia-maxilar/clark-twin-block-cusco', category: 'ortopedia-maxilar' },
  { id: 'miniImplants', path: '/ortodoncia/microimplantes-cusco', category: 'ortodoncia' },
  { id: 'thirdMolar', path: '/ortodoncia/cirugia-tercer-molar-cusco', category: 'ortodoncia' },
  { id: 'drProfile', path: '/dr-paniura/ortodoncista-cusco', category: 'dr-paniura' },
  { id: 'drApproach', path: '/dr-paniura/filosofia-tratamiento-ortodoncia', category: 'dr-paniura' },
  { id: 'drInvisalign', path: '/dr-paniura/invisalign-provider-cusco', category: 'dr-paniura' },
  { id: 'whySmileUp', path: '/clinica/ortodoncia-cusco', category: 'clinica' },
  { id: 'whyInternational', path: '/por-que/pacientes-internacionales-cusco', category: 'por-que' },
  { id: 'whyComfort', path: '/por-que/comodidad-tecnologia-ortodoncia', category: 'por-que' },
  { id: 'whyEvaluation', path: '/por-que/evaluacion-ortodoncia-personalizada', category: 'por-que' },
  { id: 'bookConsult', path: '/reservar-consulta-ortodoncia-cusco', category: 'siguiente-paso' },
  { id: 'firstAppt', path: '/primera-cita-ortodoncia-cusco', category: 'siguiente-paso' },
  { id: 'location', path: '/ubicacion-clinica-ortodoncia-cusco', category: 'siguiente-paso' },
  { id: 'firstConsult', path: '/primera-consulta-ortodoncia-cusco', category: 'recursos' },
];

const byPath = new Map(ORTHO_MENU_PAGES.map((p) => [p.path, p]));
const byId = new Map(ORTHO_MENU_PAGES.map((p) => [p.id, p]));

export function getOrthoMenuPageByPath(pathname) {
  return byPath.get(pathname) || null;
}

export function getOrthoMenuPageById(id) {
  return byId.get(id) || null;
}

export function orthoPagePath(id) {
  return byId.get(id)?.path || '/';
}

export const DR_PANIURA_PAGE_IDS = ORTHO_MENU_PAGES.filter(
  (p) => p.category === 'dr-paniura'
).map((p) => p.id);

export function isDrPaniuraPage(pageId) {
  return DR_PANIURA_PAGE_IDS.includes(pageId);
}

/** Mismo layout que /dr-paniura/ortodoncista-cusco (columna izquierda 50%). */
export const PROFILE_LAYOUT_PAGE_IDS = [...DR_PANIURA_PAGE_IDS, 'whySmileUp'];

export function usesProfileLayout(pageId) {
  return PROFILE_LAYOUT_PAGE_IDS.includes(pageId);
}

export const NEXT_STEP_PAGE_IDS = ORTHO_MENU_PAGES.filter(
  (p) => p.category === 'siguiente-paso'
).map((p) => p.id);

export const RESOURCES_PAGE_IDS = ORTHO_MENU_PAGES.filter(
  (p) => p.category === 'recursos'
).map((p) => p.id);

export function isNextStepPage(pageId) {
  return NEXT_STEP_PAGE_IDS.includes(pageId);
}

export function isResourcePage(pageId) {
  return RESOURCES_PAGE_IDS.includes(pageId);
}

export function usesLeftJustifiedLayout(pageId) {
  return (
    usesProfileLayout(pageId) ||
    pageId === 'whyInternational' ||
    pageId === 'whyComfort' ||
    pageId === 'whyEvaluation' ||
    isNextStepPage(pageId) ||
    isResourcePage(pageId)
  );
}
